package one.healthium.insights.ui.insights.components

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEach
import loco.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.insights.ui.insights.models.EmptyUiModel
import one.healthium.insights.ui.insights.models.HeaderUiModel
import one.healthium.insights.ui.insights.models.SpaceUiModel
import one.healthium.loco.resolve
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black_4
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun SavedContentList(
    uiData: List<Any>,
    onClick: (SavedContentModel) -> Unit,
    onEmptyStateClicked: () -> Unit,
) {
    LazyColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(start = 12.dp, end = 12.dp),
    ) {
        uiData.fastForEach { item ->
            when (item) {
                is SavedContentModel -> {
                    item(key = item.id, contentType = "saved_content") {
                        Spacer(Modifier.height(6.dp))
                        SavedContentItem(
                            model = item,
                            onClick = onClick,
                        )
                    }
                }

                is HeaderUiModel -> {
                    item(key = item.id, contentType = "header") {
                        Text(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(top = 24.dp, bottom = 6.dp),
                            text = item.title.resolve(),
                            style = AppTheme.textStyles.secondary_17_500,
                            color = black_4,
                        )
                    }
                }

                is EmptyUiModel -> {
                    item(key = "empty", contentType = "empty") {
                        EmptyState(
                            modifier = Modifier.fillParentMaxSize(),
                            title = item.title.resolve(),
                            message = item.message.resolve(),
                            buttonText = stringResource(loco.Res.string.INSIGHTS_FAVORITES_EMPTY_BUTTON_TEXT),
                            onClick = onEmptyStateClicked,
                        )
                    }
                }

                is SpaceUiModel -> item(contentType = "spacer") { Spacer(Modifier.height(item.valueDp.dp)) }

                else -> {}
            }
        }
    }
}